// import { GET, POST } from "../base-services";

import {
    Api_Response,
    DELETE,
    GET,
    IBase_Entity,
    PATCH,
    POST,
} from "../base-services";
import { INew_Branch } from "../branch/branch-service";

export class Organization_Service implements IOrganization_Service {
    static url = "/organization";
    static instance: Organization_Service;

    static orgs: IOrganization_Row[] = [];
    static branches: INew_Branch[] = [];

    static getInstance() {
        if (Organization_Service.instance) return Organization_Service.instance;
        else {
            Organization_Service.instance = new Organization_Service();
            return Organization_Service.instance;
        }
    }

    create_org = async (new_org: INew_Org) => {
        return POST<Create_Org_Response>(
            `${Organization_Service.url}`,
            new_org
        );
    };

    get_orgs = async (filter: any) => {
        return GET<Get_Orgs_Response>(`${Organization_Service.url}`, {
            ...filter,
        });
    };

    update_org = async (
        orgCode: IOrganization_Row["code"],
        updated_org: Partial<INew_Org>
    ) => {
        return PATCH<Update_Org_Response>(
            `${Organization_Service.url}`,
            updated_org,
            { orgCode }
        );
    };

    delete_org = async (orgCode: IOrganization_Row["code"]) => {
        return DELETE<Delete_Org_Response>(
            `${Organization_Service.url}`,
            orgCode,
            { orgCode }
        );
    };

    //
    create_branches = async (new_branches: INew_Branch[]) => {
        const response: Create_Branches_Response = [
            { success: true, message: "Branches created successfully" },
            null,
        ];

        return response;
    };
}

type Create_Org_Response = Api_Response<{
    success: true;
    message: string;
    entity: IOrganization_Row;
}>;

type Get_Orgs_Response = Api_Response<{
    success: true;
    message: string;
    rows: IOrganization_Row[];
    count: number;
}>;

type Update_Org_Response = Api_Response<{
    success: true;
    message: string;
    // rows: IOrganization_Row[];
    // count: number;
}>;

type Delete_Org_Response = Api_Response<{
    success: true;
    message: string;
    // rows: IOrganization_Row[];
    // count: number;
}>;

export type Create_Branches_Response = Api_Response<{
    success: true;
    message: string;
}>;

export interface INew_Org {
    name: string;
    code: string;
    // address: string;
    status: Organization_Status;
}

export enum Organization_Status {
    Active = "active",
    Suspended = "suspended",
}

export interface IOrganization_Row extends IBase_Entity, INew_Org {}

interface IOrganization_Service {
    create_org: (new_org: INew_Org) => Promise<Create_Org_Response>;
    get_orgs: (filter: any) => Promise<Get_Orgs_Response>;
    update_org: (
        orgCode: IOrganization_Row["code"],
        updated_org: Partial<INew_Org>
    ) => Promise<Update_Org_Response>;
    delete_org: (
        orgCode: IOrganization_Row["code"]
    ) => Promise<Delete_Org_Response>;

    create_branches: (
        new_branches: INew_Branch[]
    ) => Promise<Create_Branches_Response>;
}
